"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentCardActions = void 0;
var Utilities_1 = require("../../Utilities");
var DocumentCardActions_base_1 = require("./DocumentCardActions.base");
var DocumentCardActions_styles_1 = require("./DocumentCardActions.styles");
exports.DocumentCardActions = (0, Utilities_1.styled)(DocumentCardActions_base_1.DocumentCardActionsBase, DocumentCardActions_styles_1.getStyles, undefined, { scope: 'DocumentCardActions' });
//# sourceMappingURL=DocumentCardActions.js.map